const cities = [
  { name: "Casper", zips: "82601–82609" },
  { name: "Mills", zips: "82644" },
  { name: "Bar Nunn", zips: "82601" },
  { name: "Evansville", zips: "82636" },
  { name: "Glenrock", zips: "82637" },
  { name: "Douglas", zips: "82633" },
  { name: "Midwest", zips: "82643" },
  { name: "Edgerton", zips: "82635" },
  { name: "Natrona County", zips: "82601+" },
  { name: "Converse County", zips: "82633+" },
];

const benefits = [
  { icon: "ri-time-line", title: "No Local Agency", desc: "The nearest passport agency is in Denver — over 300 miles away. We eliminate that long drive entirely." },
  { icon: "ri-shield-check-line", title: "Registered Courier", desc: "We are a U.S. Department of State registered passport courier — Casper residents get the same access as DC residents." },
  { icon: "ri-customer-service-2-line", title: "Live Support", desc: "Real agents available by phone Mon–Fri. No bots, no ticket queues for your Casper application." },
  { icon: "ri-mail-send-line", title: "Ship from Anywhere", desc: "Ship from Casper Post Office, FedEx, or UPS. We provide tracking and confirm receipt of your documents." },
];

const internalLinks = [
  { name: "Cheyenne", route: "/cities/cheyenne" },
  { name: "Laramie", route: "/cities/laramie" },
  { name: "Jackson", route: "/cities/jackson-wy" },
  { name: "Wyoming State Hub", route: "/states/wyoming" },
  { name: "Denver CO", route: "/cities/denver" },
];

export default function LocalAreaSection() {
  return (
    <section id="service-area" className="bg-white py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center mb-14">
          <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-3">Service Area</p>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1A365D] mb-4">
            Serving Casper &amp; Natrona County
          </h2>
          <p className="text-gray-500 max-w-2xl mx-auto text-base leading-relaxed">
            Fast Passport Center serves the entire Casper metro area — Natrona County, Mills, Bar Nunn, Evansville, and surrounding central Wyoming communities. No 300-mile agency trip required.
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-start">
          <div>
            <div className="bg-[#1A365D] rounded-lg p-7 mb-8 text-white">
              <div className="flex items-center gap-3 mb-5">
                <div className="w-11 h-11 flex items-center justify-center rounded-full bg-[#F6C344] flex-shrink-0">
                  <i className="ri-passport-line text-[#1A365D] text-xl"></i>
                </div>
                <div>
                  <p className="font-bold text-base">Fast Passport Center — Serving Casper Area</p>
                  <p className="text-white/60 text-xs mt-0.5">Remotely serving all of Natrona County, WY</p>
                </div>
              </div>
              <p className="text-white/70 text-sm mb-1">
                <i className="ri-map-pin-line text-[#F6C344] mr-1.5"></i>
                Denver Regional Passport Agency — 300+ miles south via I-25
              </p>
              <p className="text-white/50 text-xs mb-5 ml-5">Courier pickup available throughout the Casper area</p>
              <div className="border-t border-white/10 pt-5">
                <p className="text-white/80 text-sm leading-relaxed mb-4">
                  Casper is Wyoming&apos;s second largest city and the hub of Natrona County. With Denver being over 300 miles away, most Casper residents simply cannot make the trip to a passport agency. We handle the entire process remotely with agency-level access.
                </p>
                <a
                  href="https://fastpassportcenter.com/checkout/"
                  className="inline-flex items-center gap-2 bg-[#F6C344] hover:bg-[#e5b430] text-[#1A365D] font-bold text-sm px-5 py-2.5 rounded-md transition-all whitespace-nowrap"
                >
                  Start My Passport <i className="ri-arrow-right-line"></i>
                </a>
              </div>
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
              {benefits.map((b, i) => (
                <div key={i} className="bg-[#F7F8FA] rounded-lg p-5 border border-gray-200">
                  <div className="w-9 h-9 flex items-center justify-center rounded-full bg-[#F6C344]/15 mb-3">
                    <i className={`${b.icon} text-[#1A365D] text-base`}></i>
                  </div>
                  <p className="font-bold text-[#1A365D] text-sm mb-1">{b.title}</p>
                  <p className="text-gray-500 text-xs leading-relaxed">{b.desc}</p>
                </div>
              ))}
            </div>
          </div>

          <div>
            <div className="bg-[#F7F8FA] rounded-lg p-7 mb-6 border border-gray-200">
              <h3 className="font-bold text-[#1A365D] text-sm uppercase tracking-wide mb-5">
                <i className="ri-map-pin-2-line text-[#F6C344] mr-2"></i>
                Cities &amp; Communities We Serve
              </h3>
              <div className="space-y-1.5">
                {cities.map((city, i) => (
                  <div key={i} className="flex items-center justify-between py-2.5 px-3 bg-white rounded-md">
                    <div className="flex items-center gap-2.5">
                      <i className="ri-checkbox-circle-fill text-[#F6C344] text-sm"></i>
                      <span className="text-[#1A365D] font-medium text-sm">{city.name}</span>
                    </div>
                    <span className="text-gray-400 text-xs font-mono">{city.zips}</span>
                  </div>
                ))}
              </div>
              <p className="text-gray-500 text-xs mt-4 leading-relaxed">
                We serve all Casper zip codes and surrounding Natrona County communities. Overnight delivery accepted from anywhere.
              </p>
              <div className="mt-4 pt-4 border-t border-gray-100">
                <p className="text-gray-400 text-xs font-semibold uppercase tracking-wider mb-3">Nearby Cities We Serve</p>
                <div className="flex flex-wrap gap-2">
                  {internalLinks.map((link) => (
                    <a
                      key={link.route}
                      href={link.route}
                      className="inline-flex items-center gap-1 text-xs text-[#1A365D] hover:text-[#F6C344] font-medium transition-colors bg-white border border-gray-200 hover:border-[#F6C344] rounded-full px-3 py-1.5 whitespace-nowrap"
                    >
                      {link.name} <i className="ri-arrow-right-line text-[10px]"></i>
                    </a>
                  ))}
                </div>
              </div>
            </div>

            <div className="bg-[#1A365D] rounded-lg p-5">
              <p className="text-white/50 text-xs uppercase tracking-widest font-semibold mb-4">Why Travelers Choose Fast Passport Center</p>
              <div className="grid grid-cols-2 gap-3">
                {[
                  { icon: "ri-government-line", value: "Registered Courier", label: "U.S. Department of State" },
                  { icon: "ri-award-line", value: "A+ Rating", label: "Better Business Bureau" },
                  { icon: "ri-calendar-check-line", value: "20+ Years", label: "Serving Travelers Nationwide" },
                  { icon: "ri-customer-service-2-line", value: "Real Humans", label: "Live Support — Not a Bot" },
                ].map((item, i) => (
                  <a key={i} href="https://fastpassportcenter.com" className="flex items-center gap-2.5 bg-white/5 hover:bg-white/10 rounded-md px-3 py-2.5 transition-colors cursor-pointer">
                    <div className="w-8 h-8 flex items-center justify-center rounded-full bg-[#F6C344]/15 flex-shrink-0">
                      <i className={`${item.icon} text-sm text-[#F6C344]`}></i>
                    </div>
                    <div className="text-left">
                      <span className="text-white text-xs font-bold block leading-tight">{item.value}</span>
                      <span className="text-white/50 text-xs leading-tight block">{item.label}</span>
                    </div>
                  </a>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}